export default "__VITE_ASSET__ca02574e__"